module.exports = __webpack_public_path__ + "img/virtual-assistant-lakeshore-splash.9694e80f.webp";